import { Column, Index } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';

/**
 * PD-16339 — an earlier original of a media item, kept when the item is
 * replaced so the previous file can be restored. The public address never
 * changes; restoring re-generates the public files from this original.
 */
@Index('idx_media_asset_version_asset', ['fkMediaAssetId'])
@Entity('media_asset_version')
export class MediaAssetVersionEntity extends BaseEntity {
	@Column('int', { name: 'fk_media_asset__id', unsigned: true })
	public fkMediaAssetId!: number;

	// The item's version number while this was its original.
	@Column('int', { name: 'version', unsigned: true })
	public version!: number;

	@Column('int', { name: 'fk__file__id', unsigned: true })
	public fkFileId!: number;

	@Column({
		type: 'varchar',
		name: 'originalName',
		length: 255,
		charset: 'utf8mb4',
		collation: 'utf8mb4_0900_ai_ci',
	})
	public originalName!: string;

	@Column('varchar', { name: 'contentType', length: 100, nullable: true })
	public contentType!: string | null;

	@Column('int', { name: 'width', unsigned: true, nullable: true })
	public width!: number | null;

	@Column('int', { name: 'height', unsigned: true, nullable: true })
	public height!: number | null;

	@Column('int', { name: 'bytes', unsigned: true, nullable: true })
	public bytes!: number | null;
}
